import {useTranslation} from 'react-i18next';
import {ErrorScene, SceneChecklist} from 'components/ErrorScene';
import {useChekinSDK} from 'context/ChekinSDK';
import {RateCountdown} from './RateCountdown';
import {isLongWait, toWholeHours} from './rateWait';

type ErrorViewVariant = 'link' | 'rate';

type ErrorViewProps = {
  variant?: ErrorViewVariant;
};

function ErrorView({variant = 'link'}: Readonly<ErrorViewProps>) {
  const {t} = useTranslation();
  const {throttleWaitSeconds} = useChekinSDK();

  if (variant === 'rate') {
    const isLong = isLongWait(throttleWaitSeconds);
    const hours = toWholeHours(throttleWaitSeconds);

    return (
      <ErrorScene
        variant="rate"
        title={isLong ? t('error_rate_title_long') : t('error_rate_title')}
        subtitle={
          isLong
            ? t('error_rate_subtitle_long', {count: hours})
            : t('error_rate_subtitle')
        }
        announce={
          isLong
            ? t('error_rate_announce_long', {count: hours})
            : t('error_rate_announce')
        }
        artClassName="lg:mt-1.5"
      >
        <RateCountdown />
      </ErrorScene>
    );
  }

  return (
    <ErrorScene
      variant="link"
      title={t('error_link_title')}
      subtitle={t('error_link_subtitle')}
      announce={t('error_link_announce')}
      artClassName="lg:mt-1.5"
    >
      <SceneChecklist
        headKey="error_link_checklist_head"
        rowKeys={['error_link_checklist_paste', 'error_link_checklist_resend']}
      />
    </ErrorScene>
  );
}

export {ErrorView};
